import { createMediaApi } from '@platform/media';
import { apiClient } from '@/shared/api/client';

/** media-service 호출부. SSOT 는 `@platform/media` — 이 앱의 apiClient 만 주입한다. */
export const mediaApi = createMediaApi(apiClient);
